import React, { ChangeEvent, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, MenuItem, Tooltip, Zoom } from '@material-ui/core';
import { Button, Container, Typography, List, ListItem, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Modal } from '@material-ui/core';
import { connect, ConnectedProps } from 'react-redux';
import store from './../redux/store';
//import { usuario } from '../redux/plans/actions';
import { fetchEmpresas } from '../redux/empresas/actions';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import ViewHeadline from '@material-ui/icons/ViewHeadline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { InputAdornment } from '@material-ui/core';
import { Email, Phone, Business, ImageSearch, FileCopy } from '@material-ui/icons';
import { getEmpresas } from '../api';
import { green } from '@material-ui/core/colors';
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import {
    useGridApiRef,
    GridRowsProp,
    GridRowModesModel,
    GridRowModes,
    DataGrid,
    GridColDef,
    GridToolbar,
    GridToolbarContainer,
    GridActionsCellItem,
    GridEventListener,
    GridRowId,
    GridRowModel,
    GridRowEditStopReasons,
    GridValueGetterParams,
    GridToolbarExport,
} from '@mui/x-data-grid';
import { Autocomplete, Avatar, Card, CardActions, CardContent, CardHeader, Collapse, Divider, LinearProgress, ListItemButton, ListSubheader, Stack, styled } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { DefaultizedPieValueType } from '@mui/x-charts';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';


import { client, AUTH_USER, getUsers, getCarrerguide, filterCategory, whoami, UPDATE_USER, CREATE_CATEGORY, REMOVE_COMPANY, CREATE_COMPANY, getCategories, UPDATE_COMPANY, REMOVE_CATEGORY, UPDATE_CATEGORY, filterCompany, CREATE_CARRERGUIDE, REMOVE_CARRERGUIDE, UPDATE_CARRERGUIDE, getPlans, CREATE_TRANSACTION, getInvoices, filterTransaction } from '../graphqlClient/graphql'
import { useMutation } from '@apollo/client';
import Notifications from './../components/notifications/Notifications';
import StripeSubscription from './../components/Stripe/Stripe';
import { UploadFile } from '@mui/icons-material';
import { serverConfig } from './../api/apiConfig';
import { color } from '@mui/system';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '100%',
        textAlign: 'center',
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        //alignItems: 'center',
        height: '100%',
    },
    content: {
        textAlign: 'center',
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    deleteButton: {
        marginLeft: theme.spacing(1),
    },
    addButton: {
        margin: theme.spacing(2),
        backgroundColor: green[500],
        color: 'white',
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    modalContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
    },
    listContainer: {
        //maxWidth:'80%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        justifyContent: 'center',
        alignItems: 'flex-start',

        maxHeight: 'calc(100vh - 100px)',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'green',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'darkgreen',
        },
    },
}));

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

type PropsFromRedux = ConnectedProps<typeof connector>;

const GetpremiumPage: React.FC<PropsFromRedux> = ({ user }) => {
    const classes = useStyles();
    const itensList = ['Aerospace and Defense', 'Airline Industry', 'Agriculture', 'Automotive', 'Banking and Financial Services', 'Biotechnology', 'Chemicals', 'Construction', 'Consumer Goods', 'Commerce', 'Crypto', 'Education', 'Electronics', 'Energy (Oil & Gas, Renewable Energy)', 'Engineering', 'Entertainment (Film, Music, Gaming)', 'Environmental Services', 'Fashion and Apparel', 'Food and Beverage', 'Forestry and Timber', 'Government and Public Administration', 'Healthcare (Hospitals, Pharmaceuticals)', 'Hospitality and Tourism', 'Insurance', 'Internet and Technology', 'Legal Services', 'Logistics and Transportation', 'Manufacturing', 'Media and Communications', 'Mining and Metals', 'Nonprofit Organizations', 'Personal Care and Cosmetics', 'Real Estate', 'Retail', 'Telecommunications', 'Textiles', 'Travel and Leisure', 'Utilities (Water, Gas, Electricity)', 'Waste Management', 'Advertising and Marketing', 'Aerospace Manufacturing', 'Airline Industry', 'Alternative Energy', 'Amusement Parks and Attractions', 'Architecture and Planning', 'Artificial Intelligence', 'Automotive Manufacturing', 'Aviation', 'Biomedical Devices', 'Broadcasting', 'Business Services', 'Clean Technology', 'Cloud Computing', 'Commercial Real Estate', 'Computer Hardware', 'Computer Software', 'Consulting', 'Defense and Space', 'Dental Services', 'E-commerce', 'Education Management', 'Electrical/Electronic Manufacturing', 'Employment Services', 'Environmental Services', 'Events Services', 'Facilities Services', 'Farming', 'Financial Technology (Fintech)', 'Fishery', 'Fitness and Wellness', 'Gambling and Casinos', 'Glass, Ceramics, and Concrete', 'Health and Wellness', 'Health Insurance', 'Higher Education', 'Human Resources', 'Import and Export', 'Industrial Automation', 'Information Technology and Services', 'Infrastructure', 'Insurance', 'Internet', 'Investment Banking', 'Legal Services', 'Leisure, Travel & Tourism', 'Logistics and Supply Chain', 'Machinery', 'Management Consulting', 'Maritime', 'Medical Devices', 'Mental Health Care', 'Nanotechnology', 'Nuclear Energy', 'Oil & Energy', 'Outsourcing/Offshoring', 'Paper & Forest Products', 'Pharmaceuticals', 'Photography', 'Plastics', 'Public Relations and Communications', 'Renewable & Environment', 'Research', 'Restaurants', 'Startup', 'Sporting Goods', 'Social Media']
    let index = 0;
    const navigate = useNavigate();
    
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
    const [selectedCategory, setSelectedCategory] = React.useState('');
    const [addCategoryModalOpen, setAddCategoryModalOpen] = React.useState(false);
    const [newCategory, setNewCategory] = React.useState<any>({});
    const [editData, setEditData] = React.useState<any>({});
    const [categories, setCategories] = React.useState<any>([]);
    const [plans, setPlans] = React.useState<any>([]);
    const [companies, setCompanies] = React.useState<any>([]);
    const [editCategoryModalOpen, setEditCategoryModalOpen] = React.useState(false);
    const [isLoadingCategories, setIsLoadingCategories] = React.useState(false);
    const [isLoadingCategoriesByFilter, setIsLoadingCategoriesByFilter] = React.useState(false);
    const [passwordOpen, setPasswordOpen] = React.useState(false);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [modalOpenFree, setModalOpenFree] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const permissoesList = ['administrador', 'gerente', 'basico']
    const [rows, setRows] = React.useState(plans);
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
    const [save, setSave] = React.useState(false);
    const [selectedUser, setSelectedUser] = React.useState<any>({ key: 0, value: 'Filtro por operador' });

    const [startDate, setStartDate] = React.useState<any>(null);
    const [endDate, setEndDate] = React.useState<any>(null);
    const [file, setFile] = React.useState<File>();
    const [image, setImage] = React.useState<any>('');
    const [openTable, setOpenTable] = React.useState<boolean>(false);
    const [open, setOpen] = React.useState<boolean>(false);
    const [uploadScreen, setUploadScreen] = React.useState<boolean>(false);
    const [imageToOpen, setImageToOpen] = React.useState<any>('');
    const [expanded, setExpanded] = React.useState('');
    const [selected, setSelected] = React.useState('');
    const [planType, setPlanType] = React.useState('free');
    const [newPlanType, setNewPlanType] = React.useState('');
   
    const apiRef = useGridApiRef();

    const handleExpandClick = (id: string) => {
        const newValue = expanded == id ? '' : id
        setExpanded(newValue);
    };

    useEffect(() => {
        console.log('user', user)
        //handleCreateAllCategories()
    }, [user])

    useEffect(() => {
        if (!isLoadingCategories && !isLoadingCategoriesByFilter && plans.length && openTable) {
            setRows(plans)
            apiRef.current.setColumnVisibility('_id', false);
        }
    }, [plans]);
    useEffect(() => {
        if (!isLoadingCategories && openTable && plans.length) {
            setRows(plans)
            apiRef.current.setColumnVisibility('_id', false);
        }


    }, [openTable]);

    /* useEffect(() => {
      changeFilter()
      
    }, [selectedUser,startDate, endDate, ]);  */

    /* const handleCreateAllCategories = ()=>{
      const data = {
        createdBy: user._id,
        description: itensList[index],
        name: itensList[index]
      }
      console.log('createCategory',data)
      handleAddCarrerguide(data)
    } */


    const getCategoriesAsync = async () => {

        const result: any = await getCategories()
        console.log('resutl ===>', result)

        if (result?.length) {
            setCategories(result)
        }
    }
    const getCarrerguideAsync = async () => {

        const result: any = await getCarrerguide()
        console.log('resutl ===>', result)

        if (result?.length) {
            setPlans(result)
        }
    }


    


    const getPlansAsync = async () => {

        const result: any = await getPlans()
        console.log('resutl plans ===>', result)

        if (result?.length) {
            setPlans(result)
        }
    }

    const getInvoicesAsync=async ()=>{
    
        const objToSend = {
            user : user._id,
            endDate,
            //empresa:empresa
            //usuario : selectedUser?._id || '',
        
        }
        console.log('objToSend', objToSend)
        const result = await filterTransaction(objToSend)
        console.log('filter result ==>>',result)
      
        if(result?.length){
            setPlanType(result[0].planType)
            
        }
    }

    useEffect(() => {
        getInvoicesAsync();
        getPlansAsync();
        //getCarrerguideAsync();
    }, []);

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            setFile(e.target.files[0]);
            setImage(URL.createObjectURL(e.target.files[0]))
        }
    };
    const clearImage = () => {
        setImage('')

    };



    const handleDeleteClick = (id: any) => {
        console.log('id', id)

        setSelectedCategory(id);
        setDeleteConfirmationOpen(true);
    };

    

    const clearNewCategory = () => {
        setNewCategory({})

    }

    


    const validateEmail = (email: any) => {
        return true
        // Implemente a lógica de validação do e-mail aqui
    };

    const validateCNPJ = (cnpj: any) => {
        // Remove caracteres não numéricos
        cnpj = cnpj.replace(/[^\d]+/g, '');

        // Verifica se possui 14 dígitos
        if (cnpj.length !== 14) {
            return false;
        }

        // Verifica se todos os dígitos são iguais (ex: 00000000000000)
        if (/^(\d)\1+$/.test(cnpj)) {
            return false;
        }

        // Validação do primeiro dígito verificador
        let sum = 0;
        let factor = 5;
        for (let i = 0; i < 12; i++) {
            sum += parseInt(cnpj[i]) * factor;
            factor = factor === 2 ? 9 : factor - 1;
        }

        let digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
        if (parseInt(cnpj[12]) !== digit) {
            return false;
        }

        // Validação do segundo dígito verificador
        sum = 0;
        factor = 6;
        for (let i = 0; i < 13; i++) {
            sum += parseInt(cnpj[i]) * factor;
            factor = factor === 2 ? 9 : factor - 1;
        }

        digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
        if (parseInt(cnpj[13]) !== digit) {
            return false;
        }

        return true;
    };


    const maskCNPJ = (cnpj: any) => {
        // Remove caracteres não numéricos
        cnpj = cnpj.replace(/[^\d]+/g, '');

        // Aplica a máscara
        cnpj = cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');

        return cnpj;
    };

    const validatePhone = (phone: any) => {
        // Remove caracteres não numéricos
        phone = phone.replace(/[^\d]+/g, '');

        // Verifica se possui 11 dígitos (considerando o DDD)
        if (phone.length !== 11) {
            return false;
        }

        // Verifica se todos os dígitos são iguais (ex: 00000000000)
        if (/^(\d)\1+$/.test(phone)) {
            return false;
        }

        return true;
    };

    const maskPhone = (phone: any) => {
        // Remove caracteres não numéricos
        phone = phone.replace(/[^\d]+/g, '');

        // Aplica a máscara
        phone = phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');

        return phone;
    };

    const handleEditCategory = (data: any) => {
        console.log('data selecionada ==>> ', data)
        setEditData(data);
        setEditCategoryModalOpen(true);
    };

    



    //init DataGrid dependencies

    const clearData = (d: any) => {
        const dateTransform = (moment(d).format('DD-MM-YYYY h:m'));
        return dateTransform
    }

    const handleRowEditStop: GridEventListener<'rowEditStop'> = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id: GridRowId) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    interface EditToolbarProps {
        setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
        setRowModesModel: (
            newModel: (oldModel: GridRowModesModel) => GridRowModesModel,
        ) => void;
    }

    const _ = (id: GridRowId) => () => {
        setRows(rows.filter((row: any) => row._id !== id));
    };

    const handleCancelClick = (id: GridRowId) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rows.find((row: any) => row._id === id);
        if (editedRow!.isNew) {
            setRows(rows.filter((row: any) => row._id !== id));
        }
    };

    const processRowUpdate: any = (newRow: GridRowModel) => {
        const updatedRow = { ...newRow, isNew: false };
        console.log('newRow', newRow)
        if (newRow.isNew) {
            delete newRow.isNew
        }
        setEditData(newRow)
        setRows(rows.map((row: any) => (row._id === newRow._id ? updatedRow : row)));
        
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const handleClickImage = () => {
        setOpen((previousOpen) => !previousOpen);
    }

    const ImageComponent = (obj: any) => {
        console.log(obj)
        //setEditReferenciaData(obj.obj.row)
        if (obj.obj.image) {
            const imagePath = serverConfig.dev.url + 'images/' + obj.obj.image;
            return (
                <div style={{ alignSelf: 'center', margin: "0 auto" }} onClick={() => {
                    //console.log(imagePath)
                    setImageToOpen(imagePath)
                    console.log(imageToOpen)
                    handleClickImage()
                }}>
                    <img style={{ objectFit: 'cover' }} height={53} src={imagePath} />
                </div>

            )
        } else {
            return (
                <IconButton onClick={
                    () => {
                        setEditData(obj.obj)
                        setUploadScreen(true)

                        //handleEditReferencia(obj.obj.row)
                    }
                }>
                    <ImageSearch />
                </IconButton>
            )
        }

    }


    const handleSaveClick = (id: GridRowId) => () => {
        const el = rows.filter((item: any) => item._id == id)
        console.log('handleSaveClick', id)
        console.log('handleSaveClick el', el)
        setSave(true)
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };
    const handleShowCompanies = (id: any) => () => {
        const el = rows.filter((item: any) => item._id == id)
        setSelectedCategory(id)
        filterCompanyByCategory(id)
    };


    const columns: GridColDef[] = [
        { field: '_id', headerName: 'ID', width: 90 },
        /* {
          field: 'imagem',
          headerName: 'Imagem',
          width: 80,
          editable: false,
          renderCell: (params) => <ImageComponent obj={params.row} />, // renderCell will render the component
        }, */
        {
            field: 'createdAt',
            headerName: 'Date',
            type: 'Date',
            width: 140,
            editable: false,
            valueGetter: (params: GridValueGetterParams) => clearData(params.row.createdAt)
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 150,
            editable: true,
            //valueGetter : (params: GridValueGetterParams)=> getCategoriaNome(params.row.categoria)
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 150,
            editable: true,
            //valueGetter : (params: GridValueGetterParams)=> getCategoriaNome(params.row.categoria)
        },
        /* {
          field: 'email',
          headerName: 'E-mail',
          width: 150,
          editable: true,
          //valueGetter : (params: GridValueGetterParams)=> getCategoriaNome(params.row.categoria)
        }, */
        {
            field: 'createdBy',
            headerName: 'Created by',
            width: 120,
            editable: false,
            valueGetter: (params: GridValueGetterParams) => params.row.createdBy.name || ''
        },



        /* {
          field: 'identificacao',
          headerName: 'código',
          description: 'código do item',
          sortable: false,
          width: 140,
          valueGetter: (params: GridValueGetterParams) =>
            `${params.row.identificacao[0].codigo || ''}  `,
        }, 
        {
          field: 'updatedAt',
          headerName: 'tipo identificacao',
          description: 'tipo de identificacao',
          sortable: false,
          width: 75,
          valueGetter: (params: GridValueGetterParams) =>
            `${params.row.identificacao[0].tipo || ''} `,
        }, */
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 150,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
                const cat = plans.filter((item: any) => item._id == id)[0]
                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }
                return [


                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        color="inherit"
                    />,

                    <GridActionsCellItem
                        icon={
                            <Tooltip TransitionComponent={Zoom} title="Delete" arrow>
                                <IconButton size='small' className='iconDetail' color="primary" aria-label="Editar" >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        label="Delete"
                        onClick={() => {
                            handleDeleteClick(id)
                        }}
                        color="inherit"
                    />,

                ];
            },
        },


    ];

    const hiddenFields = ['_id', 'id', 'ID'];

    const getTogglableColumns = (columns: GridColDef[]) => {
        console.log('getTogglableColumns', columns)
        return columns
            .filter((column) => !hiddenFields.includes(column.field))
            .map((column) => column.field);
    };

    const changeFilter = async () => {

        const objToSend = {
            startDate,
            endDate,
            //empresa:empresa
            // categoria:selectedCategory?._id || '',
            //usuario : selectedUser?._id || '',

        }
        console.log('objToSend', objToSend)
        const result = await filterCategory(objToSend)
        console.log('result ==>>', result)
        //getProductsByFilter(objToSend)
        //getCategoriesByFilter(objToSend)
        setCategories(result)

    }

    const filterCompanyByCategory = async (catId: any) => {

        const objToSend = {
            //startDate,
            //endDate,
            //empresa:empresa
            category: catId,
            //usuario : selectedUser?._id || '',

        }
        console.log('objToSend', objToSend)
        const result = await filterCompany(objToSend)
        console.log('result companies==>>', result)
        //getProductsByFilter(objToSend)
        //getCompaniesByFilter(objToSend)
        setCompanies(result)

    }

    return (
        <Container className={classes.container}>
            <Modal onClick={(evt) => {
                setImageToOpen('')
                handleClickImage()
            }} open={open} style={{
                width: '100%', textAlign: 'center', display: 'flex',
                alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'white'
            }}>
                <Box>
                    <Typography>
                        close
                    </Typography>
                    <Typography>
                        {/* {editProdutoData.referencia?.nome} */}
                    </Typography>
                    <img width={500} style={{ border: '2px solid white', maxHeight: '80vh' }}
                        src={`${imageToOpen}?w=248&fit=crop&auto=format`}
                        srcSet={`${imageToOpen}?w=248&fit=crop&auto=format&dpr=2 2x`}
                        alt={''}
                        loading="lazy"
                    />
                </Box>


            </Modal>
            <div className='{classes.root}'>
                <div className={classes.content}>
                    {/* <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button> */}
                    <Typography variant="h4" className={'title'}>
                        PRICING
                    </Typography>
                    {loading ? (
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                    ) : null}

                    <Typography>
                        Explore more with our paid plans
                    </Typography>

                    <Box sx={{ width: '100%', height: 100, }} style={{ alignSelf: 'center', paddingTop: 10, paddingBottom: 10, borderColor: 'green', borderWidth: 2 }}>
                        <Stack borderRadius={15} spacing={2} direction="column" alignItems={'center'} alignContent={'center'} divider={<Divider orientation="vertical" flexItem />}>
                            {/* <Box sx={{  width: '100%' }} style={{display: 'flex',flexDirection: 'row',flexWrap: 'nowrap',height:30, alignContent: 'center', justifyContent: 'space-around', alignSelf:'center', paddingTop:10, paddingBottom:10, borderColor:'green', borderWidth:2}}>
                  
                <Autocomplete
                    getOptionLabel={(usu:any) => usu.nome }
                    //getOptionSelected={(option:any, value:any) => option.nome === value.nome }
                    onChange={(event, newValue) => {
                        console.log(newValue)
                        setSelectedUser(newValue)        
                        changeFilter()
                        
                    }}
                    disablePortal
                    id="combo-box-usuario"
                    options={plans}
                    sx={{ width: 300 }}
                    renderInput={(params:any) => <TextField {...params} label="Operador" />}
                  />
                
                </Box> */}
                            {/*  <Box sx={{ width: '100%' }} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', height: 70, alignContent: 'center', justifyContent: 'center', alignSelf: 'center', paddingTop: 10, paddingBottom: 10, borderColor: 'green', borderWidth: 2 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker', 'DatePicker']}>
                                        <DatePicker label="Inicial"
                                           
                                            format="DD/MM/YYYY"
                                            onChange={(value: any) => {
                                                if (!value) return
                                                console.log('inicial', value.$d)
                                                setStartDate(value.$d)
                                            }}
                                        />
                                        <DatePicker label="Final"
                                            format="DD/MM/YYYY"
                                            onChange={(value: any) => {
                                                if (!value) return
                                                const valueDate = new Date(value.$d)
                                                valueDate.setHours(23)
                                                valueDate.setMinutes(59)
                                                valueDate.setSeconds(59)
                                                //console.log('day', day)
                                                console.log('final', valueDate)
                                                setEndDate(valueDate)
                                            }}

                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                                <Button className='{classes.irButton}' onClick={() => changeFilter()}>Ir</Button>
                            </Box> */}
                        </Stack>
                    </Box>
                    {
                        plans.length && !openTable ? (
                            <div className={classes.listContainer}>

                                {plans.map((item: any, index: any) => {
                                    
                                
                                        if (expanded==''||expanded==item.name) {
                                            return (<Card sx={{ width: item.name==expanded?'100%':345 , border: item.type==planType?'4px solid #31D841':null}} >
                                        
                                                <CardHeader

                                                style={item.type=="free" ? {backgroundColor:'green', color:'white'} : {backgroundColor:'red!important', color:'white'}}

                                                //style={{backgroundColor:{item.name=="most popular" ? '#341175!important':'#221175!important'}}}
                                                    /* avatar={
                                                        <Avatar sx={{ bgcolor: '#0df228' }} aria-label="recipe">
                                                            {item.name.substring(0, 2)}
                                                        </Avatar>
                                                    } */
                                                    /* action={
                                                        <IconButton aria-label="settings">
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                    } */
                                                    title={<Typography variant='h5' style={{fontWeight:'bold'}}>
                                                        {item.name.toUpperCase()}
                                                    </Typography>}
                                                   // subheader=
                                                />
                                               
                                                <CardContent style={{minHeight:'500px!important'}}>
                                                    <Typography style={{color:"#341175",fontWeight:'bold',}} variant="h4">
                                                    {`${item.price}€`}
                                                    </Typography> 
                                                    
                                                    <TextField
                                                                          style={{ border:0,marginBottom: 5, maxWidth:item.name==expanded?'90%':345, height:300 }}
                                                                          variant="outlined"
                                                                          hiddenLabel
                                                                          //label="type a word of interest to you"
                                                                          contentEditable={false}
                                                                          maxRows={12}
                                                                          multiline
                                                                          value={item.description.replaceAll('##','\n')}
                                                                          onChange={(e) => {
                                                                            //setSelectedKeywords(e.target.value)
                                                                          
                                                                            }}
                                                                            
                                                                        />
                                                </CardContent>
                                                <CardActions disableSpacing style={{minHeight:30}}>
                                                    
                                                        
                                                     {
                                                        item.type == planType ? 
                                                        <Typography variant='h6' style={{color:'white',width:'100%',textAlign:'center'}}>
                                                            YOUR CURRENT PLAN
                                                        </Typography>: 
                                                        
                                                        item.type == 'free' ? 
                                                            <Button style={{color:'white',width:'100%',textAlign:'center'}} 
                                                            onClick={() => { setModalOpenFree(true)}}
                                                            >
                                                            <Typography variant='h6' style={{color:'white',width:'100%',textAlign:'center'}}>
                                                                GET START {item.type=='free'  ?'FOR FREE' : 'WITH PREMIUM'}
                                                            </Typography>
                                                        </Button> 
                                                            : 
                                                            <Button style={{color:'white',width:'100%',textAlign:'center'}} 
                                                            onClick={() => { 
                                                                setNewPlanType(item.type);
                                                                setModalOpen(true);
                                                            }}
                                                            >
                                                            <Typography variant='h6' style={{color:'white',width:'100%',textAlign:'center'}}>
                                                                GET START {item.type=='free'  ?'FOR FREE' : 'WITH PREMIUM'}
                                                            </Typography>
                                                        </Button> 
                                                        
                                                           
                                                     } 
                                                                            
                                                    

                                                    {/* <IconButton onClick={() => {
                                                        const notData = {
                                                            type: 'success',
                                                            message: `Description copied to clipboard`,
                                                            title: 'wescout',
                                                            timeOut: 2500,
                                                            callback: () => { },
                                                            priority: true,
                                                        }
        
        
                                                        navigator.clipboard.writeText(item.description)
                                                        Notifications(notData)
                                                    }} aria-label="copy to clipboard">
                                                        <FileCopy />
                                                    </IconButton>
        
                                                    <ExpandMore
                                                        expand={expanded == item.name ? true : false}
                                                        onClick={() => { handleExpandClick(item.name) }}
                                                        aria-expanded={expanded == item.name}
                                                        aria-label="show more"
                                                    >
                                                        <ExpandMoreIcon />
                                                    </ExpandMore> */}
                                                </CardActions >
                                                {/* <Collapse in={expanded == item.name} timeout="auto" unmountOnExit>
                                                    <CardContent>
                                                        <Typography className='subtitle'>
                                                            {item.description}
                                                        </Typography>
        
                                                    </CardContent>
                                                </Collapse> */}
                                            </Card>)
                                        } 
                                        
                                        
                                        
                                       
                                    
                                    
                                }

                                )}


                            </div>
                        ) : null
                    }
                    {plans.length && openTable ? (
                        <Box sx={{ width: '100%' }}>

                            <DataGrid
                                apiRef={apiRef}
                                loading={isLoadingCategories || isLoadingCategoriesByFilter}
                                getRowId={(row: { _id: any; }) => row._id}
                                //checkboxSelection
                                disableRowSelectionOnClick

                                onClipboardCopy={(copiedString) => console.log(copiedString)}
                                unstable_ignoreValueFormatterDuringExport
                                autoHeight={true}
                                rows={rows}
                                columns={columns}
                                initialState={{
                                    sorting: {
                                        sortModel: [{ field: 'createdAt', sort: 'asc' }],
                                    },

                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                pageSizeOptions={[5]}
                                //checkboxSelection

                                //editMode="row"
                                rowModesModel={rowModesModel}
                                onRowModesModelChange={handleRowModesModelChange}
                                onRowEditStop={handleRowEditStop}
                                processRowUpdate={processRowUpdate}
                                // slots={{
                                //   toolbar: EditToolbar,
                                // }}
                                slots={{ toolbar: GridToolbar }}
                                slotProps={{
                                    toolbar: {
                                        setRows, setRowModesModel, csvOptions: {
                                            fileName: 'plansDataBase_',
                                            delimiter: ';',
                                            utf8WithBom: true,
                                        },
                                        columns: {
                                            columnVisibilityModel: { ID: false, },
                                        },
                                        columnsPanel: {
                                            getTogglableColumns,
                                        },
                                        printOptions: { hideToolbar: true, disableToolbarButton: false }
                                    },
                                }}



                            //toolbar: { printOptions: { getRowsToExport: getSelectedRowsToExport } },


                            />

                        </Box>
                    ) : (<div style={{ margin: 15 }}>

                    </div>)}


                    <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button>
                </div>
            </div>

        

            <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
                <DialogTitle>Set up your payment account</DialogTitle>
                <DialogContent className={classes.modalContent}>
                <StripeSubscription planType={newPlanType}></StripeSubscription>


                    {/* <TextField
                        label="item name"
                        value={newCategory.name}
                        onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
                    />
                    <TextField
                        label="item description"
                        value={newCategory.description}
                        onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
                    /> */}



                    {/* <FormControl fullWidth>
                  <InputLabel htmlFor="empresa-select">Selecione a Empresa</InputLabel>
                  <Select
                    value={newCategoryEmpresa}
                    onChange={(e:any) => setNewCategoryEmpresa( e.target.value )}
                    inputProps={{
                      name: 'empresa',
                      id: 'empresa-select',
                    }}
                  >
                    {empresas.map((empresa: { _id: any; nome: any; }) => (
                      <MenuItem key={empresa._id} value={empresa._id}>
                        {empresa.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel htmlFor="permissao-select">Selecione o tipo de usuário</InputLabel>
                  <Select
                    value={newCategoryPermissoes}
                    onChange={(e:any) => setNewCategoryPermissoes( e.target.value )}
                    inputProps={{
                      name: 'permissao',
                      id: 'permissao-select',
                    }}
                  >
                    {permissoesList.map((permissao: any) => (
                      <MenuItem key={permissao} value={permissao}>
                        {permissao}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}


                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setModalOpen(false)}>Close</Button>
                    {/* <Button onClick={handleAddCarrerguide} color="primary">
                        Create
                    </Button> */}
                </DialogActions>
            </Dialog>


            


            {/* <Modal open={editCategoryModalOpen} onClose={() => setEditCategoryModalOpen(false)}>
      <div>
        <input
          type="text"
          value={editData.name}
          onChange={(e) => setEditData({ ...editData, nome: e.target.value })}
        />
        <input
          type="text"
          value={editData.email}
          onChange={(e) => setEditData({ ...editData, email: e.target.value })}
        />
        <input
          type="text"
          value={editData.telefone}
          onChange={(e) => setEditData({ ...editData, telefone: e.target.value })}
        />
        <input
          type="text"
          value={editData.cnpj}
          onChange={(e) => setEditData({ ...editData, cnpj: e.target.value })}
        />
        <button onClick={handleUpdateCategory}>Atualizar</button>
      </div>
    </Modal> */}
        </Container>
    );
};

const mapStateToProps = (state: any) => ({

    user: state.user.user



});

const mapDispatchToProps = {

};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(GetpremiumPage);
